// 选择需要监听的元素
const priceElement = document.querySelector('.price-item--sale[data-sale-price]');

// 创建一个回调函数，当观察到变动时执行
const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            // 检测到子元素变化，这里我们假设是文本内容的变化
            // window.location.reload(); // 刷新页面

           const price01 =document.querySelector('.price_item01').textContent.replace(/[^\d.]/g, '')
          const priceNum01=parseFloat(price01)
          const price02 =document.querySelector('.price_item02').textContent.replace(/[^\d.]/g, '')
          const priceNum02=parseFloat(price02)
          const sumPrice01 =((priceNum02 * 100 - priceNum01 * 100) / priceNum02)

          var discountBadge = document.getElementById('discount-badge');
  if (discountBadge) {
    // 设置折扣值，确保它是一个数字，然后加上 'off' 文字
    discountBadge.textContent = Math.trunc(sumPrice01) + '% off';
  }
          // console.log('价格改变了',price01,price02,sumPrice01,discountBadge)
        }
    }
};

// 创建一个MutationObserver实例并传入回调函数
const observer = new MutationObserver(callback);

// 配置观察器选项:
const config = { attributes: false, childList: true, subtree: false };

// 使用配置好的观察器来观察目标节点
observer.observe(priceElement, config);


